//https://avinor-hms-api.herokuapp.com"
export const API_URL = "https://avinor-hms-api.herokuapp.com";
export const API_URL_LOCAL = "https://avinor-hms:8890";
